<svg x="-40" y="{{position}}" id="{{id}}" class="js-drag-button clickable"
    viewBox="-40 0 230 200"
    font-size="8px">

    <path d="m-33 10h153" fill="none" stroke="{{color}}"/>
    <text id="{{id}}-text" y="8" fill="{{color}}">{{value}}°C</text>

    <text x="26.801451" y="8" fill="{{color}}">{{label}}</text>

    {{#unless readOnly}}
    <g transform="translate(110, 4), scale(0.2)">
        {{#COMPARE activeTab '===' 'day'}}
            {{> BUTTON_RELEASED_SUN}}
        {{else}}
            {{> BUTTON_RELEASED_MOON}}
        {{/COMPARE}}
    </g>
    <g transform="translate(110, 4), scale(0.2)" style="display:none" class="pressed">
        {{#COMPARE activeTab '===' 'day'}}
            {{> BUTTON_PRESSED_SUN}}
        {{else}}
            {{> BUTTON_PRESSED_MOON}}
        {{/COMPARE}}
    </g>
    {{/unless}}
</svg>
